// src/pages/Users/Inscription/dossier/ui/DossierActionButton.jsx

import React from "react";

const VARIANTS = {
  neutral: `
    border-slate-200
    bg-white
    text-slate-600

    hover:border-slate-300
    hover:bg-slate-50
    hover:text-slate-900

    dark:border-slate-700
    dark:bg-slate-900
    dark:text-slate-300
    dark:hover:bg-slate-800
  `,

  primary: `
    border-blue-200
    bg-blue-50
    text-[#013E8E]

    hover:border-blue-300
    hover:bg-blue-100

    dark:border-blue-500/20
    dark:bg-blue-500/10
    dark:text-blue-300
  `,

  success: `
    border-emerald-200
    bg-emerald-50
    text-emerald-700

    hover:bg-emerald-100

    dark:border-emerald-500/20
    dark:bg-emerald-500/10
    dark:text-emerald-300
  `,

  danger: `
    border-rose-200
    bg-white
    text-rose-600

    hover:bg-rose-50

    dark:border-rose-500/20
    dark:bg-slate-900
    dark:text-rose-300
  `,

  amber: `
    border-amber-200
    bg-amber-50
    text-amber-700

    hover:bg-amber-100

    dark:border-amber-500/20
    dark:bg-amber-500/10
    dark:text-amber-300
  `,
};

export default function DossierActionButton({
  icon: Icon,
  children,

  variant = "neutral",

  onClick,
  disabled = false,

  type = "button",

  className = "",

  title,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`
        inline-flex
        min-h-10
        items-center
        justify-center
        gap-2

        rounded-xl
        border

        px-3
        py-2

        text-xs
        font-bold

        transition

        focus:outline-none
        focus:ring-2
        focus:ring-blue-200

        disabled:pointer-events-none
        disabled:opacity-40

        ${
          VARIANTS[
            variant
          ] ||
          VARIANTS.neutral
        }

        ${className}
      `}
    >
      {Icon ? <Icon /> : null}

      {children}
    </button>
  );
}